<div class="move-buttons">
    <app-button (click)="handlePrevious()" icon="chevron-back-outline"></app-button>
    <app-button (click)="handleToday()">{{ 'lbl_today' | translate }}</app-button>
    <app-button (click)="handleNext()" icon="chevron-forward-outline"></app-button>
</div>
